export default "__VITE_ASSET__CSLm7MPN__"